import React, { Component, Fragment } from 'react';
import "../css/spinner.css";

export default class SpinnerDiv extends React.Component
{
	circleDiv ( num )
	{
		return React.createElement ( 'div', { key: 'circ' + num, className: 'sk-circle sk-circle-' + num}) ;
	}

	renderedComponent()
	{
        let lineList = [] ;

		for (let i = 1; i < 13; i++)
		{
			lineList.push ( this.circleDiv(i)) ;
		}

        return React.createElement ( 'div', { key: 'outerDelete', className: 'sk-fading-circle ' + this.props.size}, lineList ) ;
	}

	render()
    { 
    	return  this.renderedComponent() ;
    }
};
